export default "__VITE_ASSET__DIRST0Vu__"